import type { CollectionTypeDef } from './types';
import { pickLoc } from './collections';

export type PanelNavItem = {
  id: string;
  label: string;
  description: string;
  to: string;
  area: 'core' | 'operations' | 'support';
  mobileTab?: boolean;
};

export const coreNavItems: PanelNavItem[] = [
  {
    id: 'dashboard',
    label: 'Inicio',
    description: 'Resumen de actividad, métricas y accesos rápidos.',
    to: '/',
    area: 'core',
    mobileTab: true,
  },
  {
    id: 'site',
    label: 'Sitio',
    description: 'Páginas, apariencia, contacto y publicación.',
    to: '/site',
    area: 'core',
    mobileTab: true,
  },
  {
    id: 'bookings',
    label: 'Reservas',
    description: 'Agenda, disponibilidad y reglas de atención.',
    to: '/bookings',
    area: 'operations',
  },
  {
    id: 'reputation',
    label: 'Reputación',
    description: 'Reseñas y solicitudes de retroalimentación.',
    to: '/reputation',
    area: 'operations',
  },
  {
    id: 'chatbot',
    label: 'Asistente',
    description: 'Configuración y uso del asistente del sitio.',
    to: '/chatbot',
    area: 'core',
  },
  {
    id: 'submissions',
    label: 'Consultas',
    description: 'Mensajes y clientes potenciales recibidos.',
    to: '/submissions',
    area: 'support',
    mobileTab: true,
  },
  {
    id: 'media',
    label: 'Archivos e imágenes',
    description: 'Biblioteca de recursos para el sitio.',
    to: '/media',
    area: 'support',
  },
  {
    id: 'qr',
    label: 'Códigos QR',
    description: 'Genera y descarga QR para compartir páginas o campañas.',
    to: '/qr',
    area: 'support',
  },
  {
    id: 'seo',
    label: 'SEO y visibilidad',
    description: 'Metadatos y presencia en buscadores.',
    to: '/seo',
    area: 'support',
  },
  {
    id: 'settings',
    label: 'Ajustes',
    description: 'Configuración general, usuarios y dominio.',
    to: '/settings',
    area: 'support',
  },
];

export function collectionNavItems(types: CollectionTypeDef[]): PanelNavItem[] {
  return [...types]
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((type) => ({
      id: `collection:${type.key}`,
      label: pickLoc(type.labels.plural, 'es') || type.key,
      description: `Gestiona ${pickLoc(type.labels.plural, 'es') || type.key}.`,
      to: `/c/${type.key}`,
      area: 'core' as const,
    }));
}

export function dashboardQuickActions(types: CollectionTypeDef[]): PanelNavItem[] {
  return [
    coreNavItems.find((item) => item.id === 'site'),
    ...collectionNavItems(types).slice(0, 2),
    coreNavItems.find((item) => item.id === 'submissions'),
  ].filter((item): item is PanelNavItem => Boolean(item));
}
